import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Activity } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth, formatErr } from "@/lib/auth";

export default function AuthPage({ mode }) {
  const isLogin = mode === "login";
  const submitLabel = isLogin ? "Log in" : "Create account";
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", name: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      isLogin ? await login(f.email, f.password) : await register(f.email, f.password, f.name);
      nav("/app");
    } catch (e2) { setErr(formatErr(e2)); }
    setBusy(false);
  };
  const field = (k) => ({ value: f[k], onChange: (e) => setF({ ...f, [k]: e.target.value }) });

  return (
    <div className="terminal-bg flex items-center justify-center px-4">
      <form onSubmit={submit} className="panel rise w-full max-w-sm space-y-4 p-7" data-testid={`${mode}-form`}>
        <Link to="/" className="flex items-center gap-2">
          <Activity className="h-5 w-5 text-[#00E5FF]" />
          <span className="font-display font-bold">WHALE<span className="text-[#00E5FF]">/</span>FLOW</span>
        </Link>
        <h1 className="font-display text-2xl font-bold">{isLogin ? "Welcome back" : "Create your account"}</h1>
        {!isLogin && <Input data-testid="register-name-input" placeholder="Name (optional)" {...field("name")} className="border-[#2E3C54] bg-[#0F141C]" />}
        <Input data-testid={`${mode}-email-input`} type="email" required placeholder="Email" {...field("email")} className="border-[#2E3C54] bg-[#0F141C]" />
        <Input data-testid={`${mode}-password-input`} type="password" required minLength={6} placeholder="Password (min 6 chars)" {...field("password")} className="border-[#2E3C54] bg-[#0F141C]" />
        {isLogin && (
          <div className="text-right">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-slate-400 transition-colors hover:text-[#00E5FF]">Forgot password?</Link>
          </div>
        )}
        {err && <p className="text-sm text-[#FF3D00]" data-testid={`${mode}-error`}>{err}</p>}
        <button data-testid={`${mode}-submit-button`} disabled={busy} className="w-full rounded-md bg-[#00E5FF] py-2.5 font-semibold text-[#080B10] transition-opacity hover:opacity-90 disabled:opacity-50">
          {busy ? "Please wait…" : submitLabel}
        </button>
        <p className="text-center text-sm text-slate-400">
          {isLogin ? "No account? " : "Already have one? "}
          <Link to={isLogin ? "/register" : "/login"} data-testid={`${mode}-switch-link`} className="text-[#00E5FF] hover:underline">
            {isLogin ? "Get access" : "Log in"}
          </Link>
        </p>
      </form>
    </div>
  );
}
